<template>
    <a v-if="value" :href="value" :target="target">
        <span v-if="isNil(icon)">{{ value }}</span>
        <font-awesome-icon v-if="!isNil(icon)" :icon="icon" />        
    </a>
</template>

<script>
    import isNil from 'lodash/isNil';
    
    export default {
        data() {
            return {
                value: null,
                target: null,
                icon: null,
            };
        },
        created() {
            this.value = this.params.value;
            this.target = this.params.target || '_blank';
            this.icon = this.params.icon || null;
        },
        methods: {
            isNil,
        }
    }
</script>
